import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import "../../../assets/css/utility/table.css";
import "../../../assets/css/utility/input-field.css";
import "../../../assets/css/transaction-page.css";

import useHttp from "../../../hooks/useHttp";
import store from "../../../store";
import { WITHDRAW_GET_URL } from "../../../utils/api-ends";
import { withdrawListValue } from "../../../store/slices/withdraw";

import { showModal } from "../../../store/slices/modal";

const WithdrawList = () => {

	const withdrawData = useSelector((state) => state.withdraw);
	const { sendRequests } = useHttp();
	const dispatch = useDispatch();

	const openLoadManageModal = (e) => {
        const id = e.currentTarget.dataset.id;
        dispatch(
            showModal({
              modalName: "WithdrawConfirmModal",
              modalData: {'id': id},
            })
        ); 
    }

	useEffect(() => {
        const response = (data) => {

          //setAllValue(data)
			store.dispatch(
		        withdrawListValue({
		          withdrawValue: data,
		        })
		    );
        };
        // Send request to get Withdraw list
        sendRequests(
          {
            url: WITHDRAW_GET_URL,
            method: "GET",
          },
          response
        );
	}, []);

	return (
		<>
			<section className="transaction-history">
		        <div className="container theme-section">
		            <h1 className="tr-title text-center"> Pending Withdrawal </h1>
		            <div className="transaction-table-area">
		                <div className="transaction-table">
		                    <table className="table">
		                        <thead>
		                            <tr>
		                                <th scope="col">ID</th>
		                                <th scope="col">Payment date</th>
		                                <th scope="col">Amount</th>
		                                <th scope="col"></th>
		                            </tr>
		                        </thead>        
		                        <tbody>	        
		                           {withdrawData.withdrawList?.length > 0 ?
                						withdrawData.withdrawList?.map((value, index) => (
		                            <tr>
		                                <td> {value.id} </td>
		                                <td> {value.withdrawal_date} </td>
		                                <td> $ {value.amount} </td>
		                                <td><button onClick={openLoadManageModal} data-id={value.id}>Cancle</button></td>
		                            </tr>)):
					         		<tr><p>No Withdrawal Data Available</p></tr>}
		                        </tbody>
		                    </table>
		                </div>
		            </div>
		        </div>
		    </section>
		</>
	)
}

export default WithdrawList